import { Button, VStack } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { FileWithPath, Accept } from 'react-dropzone';
import { mixed, object } from 'yup';

import { finleyAssertUnreachable } from '@finley-technologies/common';

import {
  UploadTemplateDropzone,
  UploadFileExtensionType,
} from './UploadTemplateDropzone';

const configFromFileExtensions = (
  allowedExtensions: readonly UploadFileExtensionType[],
): Accept => {
  const ret: Accept = {};
  allowedExtensions.forEach((type) => {
    switch (type) {
      case 'csv':
        ret['text/csv'] = ['.csv'];
        break;
      case 'docx':
        ret[
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ] = ['.docx'];
        break;
      case 'xlsx':
        ret[
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ] = ['.xlsx'];
        break;
      default:
        finleyAssertUnreachable(type);
    }
  });
  return ret;
};

type UploadTemplateFormProps = {
  allowedExtensions: readonly UploadFileExtensionType[];
  onClose: () => void;
  handleFile: (file: File) => Promise<void>;
  multiple?: boolean;
};
export const UploadTemplateForm = ({
  allowedExtensions,
  onClose,
  multiple,
  handleFile,
}: UploadTemplateFormProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Formik
      onSubmit={async (values) => {
        setIsLoading(true);
        try {
          if (values && values.file) {
            await handleFile(values.file);
          }
        } catch (err) {
          setIsLoading(false);
          throw err;
        }
        setIsLoading(false);
        onClose();
      }}
      validationSchema={object().shape({ file: mixed() })}
      initialValues={{ file: null }}
      validateOnChange={false}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <Form onSubmit={handleSubmit}>
          <VStack spacing="4">
            <UploadTemplateDropzone
              allowedExtensions={allowedExtensions}
              isDisabled={isLoading}
              setFieldValue={(value: FileWithPath) =>
                setFieldValue('file', value)
              }
              accept={configFromFileExtensions(allowedExtensions)}
              multiple={multiple}
            />
            <Button
              isDisabled={!values.file}
              isLoading={isLoading}
              type="submit"
            >
              Submit
            </Button>
          </VStack>
        </Form>
      )}
    </Formik>
  );
};
